<template>
  <div>
    <FormView />

    <router-view></router-view>
  </div>
</template>

<script>
import FormView from "./components/FormView.vue";

export default {
  components: {
    FormView,
  },
};
</script>
